<template>
    <li class="UserAlerts__item">
        <h4 class="UserAlerts__item-title">{{alert.title}}</h4>
        <time class="UserAlerts__item-date">{{formatDate(alert.created_at, 'dd/MM/Y')}}</time>
        <p class="UserAlerts__item-content" v-html="alert.description"></p>
        <a v-if="hasAction" class="UserAlerts__item-link" target="_blank" :href="url"><i class="fas fa-link mr-2"></i>
            {{alert.properties.action.label}}
        </a>
    </li>
</template>

<script>
    import {formatDate} from "../../utils";
    import Token from "../../services/Token";

    export default {
        props: ['alert'],
        computed: {
            hasAction: function () {
                return this.alert.properties?.action;
            },
            url: function () {
                let url = this.alert.properties?.action?.url;

                if (this.alert.properties?.type === 'CONTRACT') {
                    url += '?token=' + Token.get();
                }

                return url ?? null;
            }
        },
        methods: {
            formatDate
        }
    }
</script>
